import request from '@/utils/request'


// 查询首页活动配置列表
export function listHomeConfig(query) {
  return request({
    url: '/homeConfig/homeConfig/list',
    method: 'get',
    params: query
  })
}

// 查询首页活动配置分页
export function pageHomeConfig(query) {
  return request({
    url: '/homeConfig/homeConfig/page',
    method: 'get',
    params: query
  })
}

// 查询首页活动配置详细
export function getHomeConfig(data) {
  return request({
    url: '/homeConfig/homeConfig/detail',
    method: 'get',
    params: data
  })
}

// 新增首页活动配置
export function addHomeConfig(data) {
  return request({
    url: '/homeConfig/homeConfig/add',
    method: 'post',
    data: data
  })
}

// 修改首页活动配置
export function updateHomeConfig(data) {
  return request({
    url: '/homeConfig/homeConfig/edit',
    method: 'post',
    data: data
  })
}

// 删除首页活动配置
export function delHomeConfig(data) {
  return request({
    url: '/homeConfig/homeConfig/delete',
    method: 'post',
    data: data
  })
}
